import { axios } from "@/services/axios";
import { extend, map } from "lodash";

export const CHAINS = {
  1: "mainnet",
  56: "bsc",
  137: "polygon",
  8453: "base",
  84532: "base_sepolia",
  42161: "arbitrum",
  43114: "avalanche",
  42220: "celo",
  10: "optimism",
  421613: "arbitrum_sepolia",
  10000: "gnosis",
  100: "xdai",
};


class SmartContract {
  constructor(smartContract) {
    extend(this, smartContract);
  }

  getChainName() {
    return CHAINS[this.chain_id] || "unknown";
  }
}

const getSmartContract = smartContract => new SmartContract(smartContract);

const SmartContractService = {
  get: data => axios.get(`api/smart_contracts/${data.id}`).then(getSmartContract),
  query: () => axios.get("api/smart_contracts").then(data => map(data, getSmartContract)),
  create: data => axios.post("api/smart_contracts", data).then(getSmartContract),
  save: data => axios.post(`api/smart_contracts/${data.id}`, data).then(getSmartContract),
  delete: data => axios.delete(`api/smart_contracts/${data.id}`),
  getRpcUrl: data => axios.get(`api/smart_contracts/${data.id}/rpc_url`),
};

export default SmartContractService;
